module.exports = __webpack_public_path__ + "static/media/period_ban_dis.9646efc3.svg";